import React from 'react'

export default function Disclaimer() {
  return (
    <div className="bg-info text-dark mt-2 p-3 mb-1">
      <div className="container">
        <p className="text-center fw-bold mb-2">Disclaimer</p>
        <p className="mb-0 text-justify">
          All logos and trademarks displayed on this website are the property of their respective brands and are used solely for illustrative purposes.  If you have any concerns or believe your logo has been used inappropriately, please contact us at
          <a href="mailto:info@esellersupport.in" className="text-dark fw-semibold"> info@esellersupport.in</a>, and we will address your concerns promptly.
        </p>
      </div>
    </div>

  )
}

